export default "__VITE_ASSET__BA5i17d5__"